const PREFIX = ['research', 'component'];
export function createComponentRepository(config) {
    const { repository } = config;
    function getFindQueryKey(props) {
        return [...PREFIX, 'find', props];
    }
    return {
        useFind(context, props, options) {
            const query = repository.useQuery({
                ...options,
                queryKey: getFindQueryKey(props),
                async queryFn() {
                    // Static data for now - later will wire up to API
                    const components = [
                        {
                            id: 'interview',
                            kind: 'interview',
                            name: 'Interview',
                            description: 'One-on-one conversation for qualitative insights',
                            summary: 'Conduct in-depth conversations',
                            category: 'research',
                            icon: '🎤',
                        },
                        {
                            id: 'survey',
                            kind: 'survey',
                            name: 'Survey',
                            description: 'Structured questionnaire for data collection',
                            summary: 'Gather structured feedback and insights',
                            category: 'data-collection',
                            icon: '📋',
                        },
                        {
                            id: 'form',
                            kind: 'form',
                            name: 'Form',
                            description: 'Interactive form for user input and data capture',
                            summary: 'Collect user information efficiently',
                            category: 'input',
                            icon: '📝',
                        },
                        {
                            id: 'collection',
                            kind: 'collection',
                            name: 'Collection',
                            description: 'Organized grouping of related content items',
                            summary: 'Organize and manage content collections',
                            category: 'organization',
                            icon: '🗂️',
                        },
                    ];
                    return components;
                },
            });
            return query;
        },
    };
}
//# sourceMappingURL=componentRepository.js.map